// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    updateCustomerPartNumber,
    UpdateCustomerProductNumberApiParameter,
} from "@keller/App/Services/CustomerProductNumberService";

type HandlerType = ApiHandler<
    UpdateCustomerProductNumberApiParameter & HasOnSuccess & HasOnError<string>,
    UpdateCustomerProductNumberApiParameter
>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await updateCustomerPartNumber(props.apiParameter);
    } catch (error) {
        if (error.status === 500) {
            props.parameter.onError?.(siteMessage("Keller_Internal_Service_Error_Msg") as string);
        } else {
            const failedMessage =
                error.errorMessage  || "Please try again and contact support if you continue to have issues.";
            props.parameter.onError?.(failedMessage);
        }
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const updateCustomerProductNumber = createHandlerChainRunner(chain, "updateCustomerProductNumber");

export { updateCustomerProductNumber };
